import React from "react";
import { L10n } from "@fidget/common/i18n";
import styles from "./widgetMaintenance.css";
import classNames from "classnames";
import { SadFace } from "@fidget/common/components/icons/sadFace/sadFace";

export const WidgetMaintenance = (props: { message?: string }) => (
  <div className={classNames(styles.wrapper, styles.overlay)}>
    <header>
      <SadFace style={{ margin: "auto" }} />
      <h2>
        { props.message || <L10n id={"widget.initialization.maintenance"} /> }
      </h2>
    </header>
  </div>
);
